import { render, staticRenderFns } from "./SignaturesView.vue?vue&type=template&id=c49bc09a"
import script from "./SignaturesView.vue?vue&type=script&lang=js"
export * from "./SignaturesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports